<template>
  <el-button
     class="el-button--nuttrema-radiocheck-button"
    :type="buttonType"
    :class="{ 'is-active': isActive, 'is-future': future }"
    :value="label"
    :size="size"
    :disabled="isDisabled"
    @click="handleClick">
    <slot></slot>
  </el-button>
</template>

<script>
import { includes, size } from 'lodash';
import Emitter from 'components/mixins/emitter';

export default {
  name: 'nuttrema-radiocheck-button',
  componentName: 'NuttremaRadiocheckButton',
  mixins: [Emitter],
  props: {
    label: {
      required: true,
      default: null,
    },
    required: Boolean,
    disabled: Boolean,
    future: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonType: String,
    buttonSize: String,
  },
  methods: {
    handleClick() {
      if (this.future) return;

      // in case of radio group check is label equal to current value
      // in case of checkbox group check is label included in array of values
      const equalOrIncludes = this.isRadio ? this.label === this.value : includes(this.value, this.label);

      // if required allways set, if not check is equal or included, if it is remove it (case of toggle)
      const action = this.isRequired ? this.radiocheckGroup.ACTIONS.SET : (equalOrIncludes ? this.radiocheckGroup.ACTIONS.UNSET : this.radiocheckGroup.ACTIONS.SET);

      console.log('handleClick', this.isRequired, action);
      this.dispatch('NuttremaRadiocheckGroup', 'handleChange', { value: this.label, action });
    },
  },
  computed: {
    value: {
      get() {
        return this.radiocheckGroup.value;
      },
    },
    size() {
      return this.buttonSize || this.radiocheckGroup.size;
    },
    radiocheckGroup() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'NuttremaRadiocheckGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }
      return false;
    },
    isRequired() {
      const parentRequired = this.radiocheckGroup.required;
      const requiredFromParent = parentRequired ? (this.isRadio ? parentRequired : (parentRequired && size(this.value) === 1)) : false;
      return this.required || requiredFromParent;
    },
    isRadio() {
      return this.radiocheckGroup.mode === this.radiocheckGroup.MODES.RADIO;
    },
    isActive() {
      return this.isRadio ? this.value === this.label : includes(this.value, this.label);
    },
    isDisabled() {
      return this.radiocheckGroup.disabled || this.disabled;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/button/nuttrema-radiocheck-button.vue